/**
 * Check if value instance of class
 * @param {*} cls
 * @param {*} instance
 * @returns {boolean}
 */
export function isInstanceOf(cls, instance) {

    return instance instanceof cls;
}

/**
 * Check if value has expected type
 * @param {string} type
 * @param {*} value
 * @returns {boolean}
 */
export function isTypeOf(type, value) {

    return typeof value === (
        "" + type
    );
}

/**
 * Assert that instance of expected class
 * @param {*} cls
 * @param {*} instance
 * @throws {TypeError}
 */
export function expectsInstance(cls, instance) {

    if (!isInstanceOf(cls, instance)) {

        throw new TypeError("Instance of '" + cls.name + "' expected, but given: " + instance);
    }
}

/**
 * Assert that value of expected type
 * @param {string} type
 * @param {*} value
 * @throws {TypeError}
 */
export function expectsType(type, value) {

    if (!isTypeOf(type, value)) {
        throw new TypeError("Type of '" + type + "' expected, but given: " + (
            typeof value
        ));
    }
}

/**
 * @param {Function} cls
 * @param {Function} parentCls
 * @returns {boolean}
 */
export function checkClass(cls, parentCls) {

    return cls === parentCls || isInstanceOf(parentCls, cls.prototype);
}

export function value(value, ...args) {

    return isTypeOf('function', value) ? value(...args) : value;
}


// WEBPACK FOOTER //
// ./src/helpers/types.js